import React, { FC } from 'react';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';

interface Props {
    image: string;
    onBack: (event: any) => void;
    onNext: (event: any) => void;
}

const CameraCaptureForm: FC<Props> = ({ image, onBack, onNext }) => {
    const { translate } = useLocale();

    const onLocalNext = (event: any) => {
        if (image != '') {
            onNext({ ...event });
        }
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.imageCaptured)}:</h2>
                {image != '' ?
                    <img className=" max-w-full h-full object-contain"
                        src={`${image}`}
                        alt="user" /> : null}
            </div>
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={(event) => onBack(event)}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${image != '' ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={(e) => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default CameraCaptureForm;
